import type { Messages } from '@/types'

// Placeholder Italian translations - to be completed with proper translations
const messages: Messages = {
    common: {
        actions: {
            add: 'Aggiungi',
            edit: 'Modifica',
            delete: 'Elimina',
            cancel: 'Annulla',
            back: 'Indietro',
            save: 'Salva',
            update: 'Aggiorna',
            reset: 'Reimposta',
            refresh: 'Aggiorna',
            backToList: '@:common.back alla lista',
            resetDefaults: '@:common.reset ai valori predefiniti',
            confirm: 'Conferma',
            proceed: 'Procedi',
            close: 'Chiudi',
            apply: 'Applica',
            search: 'Cerca',
            filter: 'Filtra',
            clear: 'Pulisci',
            select: 'Seleziona',
            upload: 'Carica',
            download: 'Scarica',
            view: 'Visualizza',
            sort: 'Ordina',
            seeMore: 'Vedi di più'
        },
        status: {
            success: 'Successo',
            error: 'Errore',
            loading: 'Caricamento...'
        },
        messages: {
            deleteConfirm: 'Sei sicuro di voler eliminare questo utente?',
            generalError: 'Qualcosa è andato storto! Per favore riprova',
            addSuccess: 'Record aggiunto con successo!',
            updateSuccess: 'Record aggiornato con successo!',
        },
        placeholder: {
            avatar: '?'
        },
        labels: {
            loading: 'Caricamento',
            noResults: 'Nessun risultato trovato',
            noData: 'Nessun dato disponibile',
            selected: 'Selezionato',
            required: 'Richiesto',
            optional: 'Opzionale',
            search: 'Cerca...',
            filter: 'Filtra...',
            from: 'Da',
            to: 'A',
            date: 'Data',
            status: 'Stato',
            item: 'Elemento {index}',
            addItem: 'Aggiungi Elemento',
            removeItem: 'Rimuovi Elemento',
            skipToMain: 'Vai al contenuto principale',
            openNavigation: 'Apri navigazione',
            closeNavigation: 'Chiudi navigazione',
            mainNavigation: 'Navigazione principale',
            moveUp: 'Sposta Su',
            moveDown: 'Sposta Giù'
        },
        errors: {
            upload: 'Caricamento file non riuscito',
            download: 'Download file non riuscito',
            generic: 'Si è verificato un errore',
            notFound: 'Non trovato',
            unauthorized: 'Accesso non autorizzato',
            validation: 'Si prega di controllare i dati inseriti'
        },
        validation: {
            required: 'Questo campo è obbligatorio',
            email: 'Indirizzo email non valido',
            minLength: 'Lunghezza minima è {length}',
            maxLength: 'Lunghezza massima è {length}',
            min: 'Valore minimo è {min}',
            max: 'Valore massimo è {max}',
            matches: 'Formato non valido',
            unique: 'Il valore deve essere unico',
            confirm: 'Le password non corrispondono'
        }
    },
    pages: {
        users: {
            title: 'Utenti',
            description: 'Gestisci gli utenti del sistema',
            actions: {
                invite: 'Invita Utente',
                resetPassword: 'Reimposta Password'
            }
        },
        settings: {
            title: 'Impostazioni',
            actions: {
                resetDefaults: 'Reimposta ai valori predefiniti'
            }
        },
        reports: {
            title: 'Rapporti',
            description: 'Genera e scarica rapporti',
            actions: {
                generateReport: 'Genera Rapporto',
                downloadCsv: 'Scarica CSV',
                startDate: 'Data di Inizio',
                endDate: 'Data di Fine',
                apps: 'App',
            },
            error: {
                generation: 'Generazione rapporto non riuscita',
                download: 'Download rapporto non riuscito'
            }
        }
    },
    navigation: {
        home: 'Home',
        library: 'Biblioteca',
        search: 'Cerca',
        login: 'Accedi',
        signInToGetPremium: 'Ottieni Premium',
        subscribe: 'Abbonati',
        support: 'Supporto',
        settings: 'Impostazioni',
        logout: 'Esci'
    },
    settings: {
        title: 'Impostazioni',
        description: 'Gestisci le impostazioni del tuo account, le preferenze e le informazioni del profilo.',
        sections: 'Sezioni Impostazioni',
        menu: {
            profile: 'Profilo',
            account: 'Account',
            general: 'Generale',
            purchases: 'Acquisti',
            activity: 'Attività'
        },
        profile: {
            title: 'Profilo',
            changeImage: 'Cambia Immagine',
            updateProfile: 'Aggiorna Profilo',
            changePassword: 'Cambia Password',
            updatePassword: 'Aggiorna Password',
            fields: {
                fullName: 'Nome Completo',
                emailAddress: 'Indirizzo Email',
                dateOfBirth: 'Data di Nascita',
                currentPassword: 'Password Attuale',
                newPassword: 'Nuova Password',
                confirmNewPassword: 'Conferma Nuova Password'
            },
            toasts: {
                imageUpdated: 'Immagine Aggiornata',
                imageUpdatedMessage: 'La tua immagine del profilo è stata aggiornata con successo',
                uploadFailed: 'Caricamento Fallito',
                profileUpdated: 'Profilo Aggiornato',
                profileUpdatedMessage: 'Il tuo profilo è stato aggiornato con successo',
                passwordUpdated: 'Password Aggiornata',
                passwordUpdatedMessage: 'La tua password è stata aggiornata con successo',
                passwordError: 'Errore Password',
                passwordMismatch: 'Le password non corrispondono',
                passwordTooWeak: 'La password è troppo debole'
            }
        },
        account: {
            title: 'Account',
            accountInformation: 'Informazioni Account',
            emailAddress: 'Indirizzo Email',
            memberSince: 'Membro dal',
            redeemPromoCode: 'Riscatta codice promozionale',
            redeemPromoCodeDescription: 'Hai un codice promozionale o regalo? Inseriscilo qui per applicarlo al tuo account o al prossimo abbonamento.',
            subscription: {
                title: 'Abbonamento',
                currentPlan: 'Piano Attuale',
                premiumSubscription: 'Abbonamento Premium',
                nextRenewal: 'Prossimo rinnovo:',
                accessUntil: 'Accesso fino al:',
                manageInAppStore: 'Il tuo abbonamento è stato acquistato tramite App Store. Per annullarlo o modificarlo, apri Abbonamenti nelle impostazioni del tuo Apple ID sul dispositivo usato per abbonarti.',
                manageInPlayStore: 'Il tuo abbonamento è stato acquistato tramite Google Play. Per annullarlo o modificarlo, apri Abbonamenti nel Google Play Store sul dispositivo usato per abbonarti.',
                notSubscribed: 'Non sei attualmente abbonato a nessun piano.',
                subscribeNow: 'Abbonati Ora',
                findOutMore: 'Scopri di più',
                cancelSubscription: 'Annulla Abbonamento',
                cancelSubscriptionTitle: 'Annulla Abbonamento',
                cancelSubscriptionMessage: 'Sei sicuro di voler annullare il tuo abbonamento? Perderai l\'accesso ai contenuti premium alla fine del periodo di fatturazione attuale.',
                keepSubscription: 'Mantieni Abbonamento',
                toasts: {
                    subscriptionActivated: 'Abbonamento Attivato',
                    subscriptionActivatedMessage: 'Benvenuto su Premium!',
                    subscriptionFailed: 'Abbonamento Fallito',
                    paymentMethodUpdated: 'Metodo di Pagamento Aggiornato',
                    paymentMethodUpdatedMessage: 'Le tue informazioni di pagamento sono state aggiornate con successo',
                    subscriptionCancelled: 'Abbonamento Annullato',
                    subscriptionCancelledMessage: 'Il tuo abbonamento terminerà al periodo di fatturazione attuale',
                    cancellationFailed: 'Annullamento Fallito'
                }
            },
            closeAccount: {
                title: 'Chiudi Account',
                requestDescription: 'Richiedi la chiusura permanente del tuo account. Questa azione non può essere annullata.',
                requestButton: 'Richiedi Chiusura Account',
                confirmationTitle: 'Sei sicuro di voler disattivare il tuo account? Questo farà:',
                confirmationItems: {
                    cancelSubscription: 'Annullare il tuo abbonamento attivo (se presente)',
                    removeCommunications: 'Rimuovere da tutte le comunicazioni',
                    scheduleDeletion: 'Programmare l\'eliminazione permanente dei tuoi dati dopo 30 giorni'
                },
                confirmationWarning: 'Puoi annullare la tua richiesta di disattivazione in qualsiasi momento entro 30 giorni. Dopo questo periodo, il tuo account e tutti i dati associati saranno eliminati permanentemente.',
                confirmationCheckbox: 'Comprendo che il mio account sarà eliminato permanentemente dopo 30 giorni',
                deactivateAccount: 'Disattiva Account',
                cancel: 'Annulla',
                scheduledTitle: 'Disattivazione Account Programmata',
                scheduledMessage: 'Il tuo account è programmato per essere eliminato permanentemente il',
                scheduledWarning: 'Durante questo periodo, non potrai accedere al tuo account. Se cambi idea, puoi annullare il processo di disattivazione.',
                cancelDeactivation: 'Annulla Disattivazione Account',
                toasts: {
                    deactivationRequested: 'Disattivazione Account Richiesta',
                    deactivationRequestedMessage: 'Il tuo account sarà eliminato permanentemente tra 30 giorni',
                    deactivationFailed: 'Disattivazione Fallita',
                    deactivationCancelled: 'Disattivazione Annullata',
                    deactivationCancelledMessage: 'Il tuo account non è più programmato per l\'eliminazione'
                }
            }
        },
        purchases: {
            title: 'Cronologia Acquisti',
            noPurchases: 'Nessun acquisto trovato',
            invoice: 'Fattura'
        },
        activity: {
            title: 'Cronologia Attività',
            dateRange: 'Intervallo Date',
            activityType: 'Tipo di Attività',
            noActivities: 'Nessuna attività trovata',
            resume: 'Riprendi',
            loadMore: 'Carica Altro',
            filters: {
                last7Days: 'Ultimi 7 giorni',
                last30Days: 'Ultimi 30 giorni',
                lastYear: 'Ultimo anno',
                allTime: 'Tutto il tempo',
                allActivities: 'Tutte le Attività',
                listening: 'Ascolto',
                purchases: 'Acquisti',
                likes: 'Mi Piace',
                bookmarks: 'Segnalibri'
            },
            types: {
                listenedTo: 'Ascoltato {title}',
                purchased: 'Acquistato {title}',
                liked: 'Mi è piaciuto {title}',
                bookmarked: 'Segnalibro {title}'
            }
        },
        appSettings: {
            title: 'Impostazioni App',
            darkMode: 'Modalità Scura',
            language: 'Lingua',
            languageOptions: {
                english: 'Inglese',
                spanish: 'Spagnolo',
                french: 'Francese',
                german: 'Tedesco',
                italian: 'Italiano',
                portuguese: 'Portoghese',
                dutch: 'Olandese',
                slovak: 'Slovacco',
                russian: 'Russo',
                arabic: 'العربية'
            }
        },
        notifications: {
            title: 'Notifiche',
            emailNotifications: 'Notifiche Email',
            emailNotificationsHint: 'Ricevi aggiornamenti via email',
            pushNotifications: 'Notifiche Push',
            pushNotificationsHint: 'Ricevi notifiche push',
            updatePreferences: 'Aggiorna Preferenze'
        },
        toasts: {
            themeUpdated: 'Tema Aggiornato',
            themeUpdatedMessage: 'La tua preferenza del tema è stata salvata',
            languageUpdated: 'Lingua Aggiornata',
            languageUpdatedMessage: 'La tua preferenza della lingua è stata salvata',
            preferencesUpdated: 'Preferenze Aggiornate',
            preferencesUpdatedMessage: 'Le tue preferenze di notifica sono state salvate',
            updateFailed: 'Aggiornamento Fallito',
            updateFailedMessage: 'Errore nell\'aggiornamento dell\'impostazione',
            updateFailedNotificationMessage: 'Errore nell\'aggiornamento delle preferenze di notifica'
        }
    },
    auth: {
        login: {
            title: 'Accedi',
            description: 'Accedi al tuo account Heard per accedere alla tua biblioteca e ai contenuti premium',
            signIn: 'Accedi',
            signInToAccount: 'Accedi al tuo account',
            noAccount: 'Non hai un account?',
            signUp: 'Registrati',
            continueAsGuest: 'Continua come ospite',
            or: 'O',
            agreeToTerms: 'Accedendo, accetti i nostri',
            termsOfService: 'Termini di Servizio',
            privacyPolicy: 'Informativa sulla Privacy'
        },
        register: {
            title: 'Registrati',
            description: 'Crea un nuovo account Heard per accedere alla tua biblioteca e ai contenuti premium'
        }
    },
    player: {
        chapters: 'Capitoli',
        options: 'Opzioni',
        playbackSpeed: 'Velocità di Riproduzione',
        share: 'Condividi',
        linkCopied: 'Link Copiato',
        linkCopiedMessage: 'Link di condivisione copiato negli appunti!',
        shareError: 'Errore di Condivisione',
        shareErrorMessage: 'Impossibile copiare il link. Riprova.',
        bookmarkAdded: 'Successo',
        bookmarkAddedMessage: 'Segnalibro aggiunto!',
        jumpedToBookmark: 'Successo',
        jumpedToBookmarkMessage: 'Saltato al segnalibro!',
        likeError: 'Errore Mi Piace',
        likeErrorMessage: 'Impossibile aggiornare lo stato mi piace. Riprova.',
        bookmarkError: 'Errore Segnalibro',
        bookmarkErrorMessage: 'Impossibile aggiornare il segnalibro. Riprova.',
        favorites: {
            add: 'Aggiungi ai Preferiti',
            remove: 'Rimuovi dai Preferiti'
        },
        unknownChapter: 'Capitolo Sconosciuto',
        unknownTitle: 'Titolo Sconosciuto',
        unknownAuthor: 'Autore Sconosciuto'
    },
    details: {
        starring: 'Protagonisti:',
        author: 'Autore',
        narrator: 'Narratore',
        pause: 'Pausa',
        purchased: 'Acquistato',
        continueReading: 'Continua la Lettura',
        continuePlaying: 'Continua la Riproduzione',
        play: 'Riproduci',
        loading: 'Caricamento...',
        noChapters: 'Nessun capitolo disponibile',
        chapterFreeLabel: 'Gratis',
        listen: 'Ascolta',
        purchaseSuccess: 'Acquisto riuscito',
        purchaseSuccessMessage: '{title} è stato aggiunto alla tua libreria',
        subscriptionSuccess: 'Abbonamento riuscito',
        subscriptionSuccessMessage: 'Benvenuto su Heard Premium!',
        subscriptionFailed: 'Abbonamento fallito',
        subscriptionErrorMessage: 'Si è verificato un errore durante l\'elaborazione del tuo abbonamento.',
        info: 'Info',
        more: 'Altro',
        episodes: 'Episodi',
        about: 'Informazioni',
        series: 'Serie',
        producedBy: 'Prodotto da',
        recommendations: 'Potrebbe piacerti anche',
        moreFromCategory: 'Altro da {name}',
        moreFromAuthor: 'Altro da {name}',
        moreFromCast: 'Altro da {name}',
        moreFromSeries: 'Altro in {name}',
        noRelated: 'Nessun titolo correlato disponibile al momento.',
        ageVerification: {
            title: 'Solo per adulti',
            message: 'Questo contenuto è riservato agli adulti. Conferma di voler continuare.',
            minAgeHint: 'Devi avere almeno {age} anni per vedere questo titolo.',
            confirm: 'Sono un adulto, continua',
            cancel: 'Annulla',
            missingDobTitle: 'Data di nascita richiesta',
            missingDobMessage: 'Aggiungi la data di nascita nel profilo per vedere questo contenuto.',
            underageTitle: 'Limitato per età',
            underageMessage: 'Devi avere almeno {age} anni per vedere questo contenuto.',
        },
    },
    shareModal: {
        title: 'Condividi',
        copyLink: 'Copia link',
        copyLinkWithMessage: 'Copia link con messaggio',
        copyLinkWithMessageHint: 'Titolo e descrizione inclusi',
        shareVia: 'Condividi tramite...',
        shareViaHint: 'App, messaggi, email',
        linkCopied: 'Link copiato',
        linkCopiedMessage: 'Link copiato negli appunti!',
        shared: 'Condiviso',
        sharedMessage: 'Contenuto condiviso con successo'
    },
    contextMenu: {
        playFromBeginning: 'Riproduci dall\'Inizio',
        markAsFinished: 'Segna come Completato',
        addToFavorites: 'Aggiungi ai Preferiti',
        removeFromFavorites: 'Rimuovi dai Preferiti',
        share: 'Condividi',
        viewDetails: 'Visualizza Dettagli',
        removeFromLibrary: 'Rimuovi dalla Libreria',
        continuePlaying: 'Continua la Riproduzione',
        continueReading: 'Continua la Lettura'
    },
    actions: {
        subscribe: 'Abbonati',
        signInToGetPremium: 'Ottieni Premium',
        purchase: 'Acquista',
        buy: 'Acquista',
        buyFor: 'Acquista per {price}',
        purchasedGoToLibrary: 'Acquistato - Vai alla Libreria',
        addToFavorites: 'Aggiungi ai preferiti',
        removeFromFavorites: 'Rimuovi dai preferiti',
        share: 'Condividi'
    },
    browse: {
        sortBy: 'Ordina per',
        sortOptions: {
            recent: 'Recenti',
            ascending: 'A-Z',
            descending: 'Z-A'
        }
    },

    legal: {
        companyNumber: 'N. azienda',
        privacyPolicy: 'Informativa sulla privacy',
        termsOfService: 'Termini di servizio',
        agreeToTermsSubscribe: 'Abbonandoti, accetti i nostri',
        operatedBy: '{appName} è gestito da {companyName}, {address}',
        faqs: 'FAQ'
    },
    support: {
        title: 'Supporto',
        description: 'Hai bisogno di aiuto con il tuo account, abbonamento o esperienza di ascolto? Consulta le FAQ e le informazioni legali, oppure inviaci un messaggio.',
        intro: 'Hai bisogno di aiuto con il tuo account, abbonamento o esperienza di ascolto? Consulta le FAQ e le informazioni legali qui sotto, oppure contattaci se hai bisogno di ulteriore assistenza.',
        quickLinks: 'Link rapidi',
        contactTitle: 'Contatta il supporto',
        contactDescription: 'Invia un messaggio al nostro team di supporto. Consulta prima le FAQ per risposte rapide.',
        contactIntro: 'Se hai bisogno di aiuto, siamo qui per te. Molte domande comuni hanno già una risposta nel nostro centro assistenza.',
        contactIntroFaqBefore: 'Consulta le nostre ',
        contactIntroFaqAfter: ' per le risposte alle domande più comuni. Se hai ancora bisogno di aiuto, compila il modulo e ti risponderemo il prima possibile.',
        contactSubmit: 'Invia messaggio',
        contactName: 'Nome',
        contactEmail: 'Email',
        contactSubject: 'Oggetto',
        contactMessage: 'Messaggio',
        contactMessageHint: 'Descrivi il problema in dettaglio',
        backToSupport: 'Torna al supporto',
        pageLoading: 'Caricamento…',
        pageNotAvailable: 'Questa pagina non è disponibile al momento.',
        unsupportedSection: 'Sezione contenuto non supportata: {name}',
        useContactFormBefore: 'Hai bisogno di contattarci? Usa il nostro ',
        contactSuccessTitle: 'Messaggio inviato',
        contactSuccessMessage: 'Il tuo messaggio è stato inviato. Ti risponderemo il prima possibile.',
        contactErrorTitle: 'Invio fallito',
        contactErrorMessage: 'Impossibile inviare il messaggio. Riprova.'
    },
    promo: {
        haveCode: 'Hai un codice promozionale?',
        placeholder: 'Inserisci il codice',
        apply: 'Applica',
        remove: 'Rimuovi',
        applied: '{name} – {discount}',
        invalidCode: 'Codice non valido o scaduto.',
        expired: 'Questo codice è scaduto.',
        notValidForPurchase: 'Questo codice non è valido per questo acquisto.',
        free: 'Gratis',
        percentOff: '{value}% di sconto',
        fixedOff: '{value} di sconto',
        useWhenSubscribe: 'Usa questa offerta quando ti abbonerai qui sotto.',
        useWhenPurchase: 'Usa questo codice quando acquisti un titolo.',
        accessGranted: 'L\'accesso è stato applicato al tuo account.'
    }
}

export default messages

